module.exports = __webpack_public_path__ + "static/media/intSlide02.0a41cb20.jpg";